import QualityList from './QualityList';

export default QualityList;
